import { useState, useRef } from 'react'
import { router } from '@inertiajs/react'
import AdminLayout from '../../layouts/AdminLayout'

function PhotoCard({ photo, editionSlug }) {
  const [caption, setCaption] = useState(photo.caption || '')

  function saveCaption() {
    if (caption === (photo.caption || '')) return
    router.patch(
      `/photos/${photo.id}`,
      { edition_slug: editionSlug, photo: { caption } },
      { preserveScroll: true }
    )
  }

  function remove() {
    if (!confirm('Eliminar esta foto?')) return
    router.delete(`/photos/${photo.id}`, {
      data: { edition_slug: editionSlug },
      preserveScroll: true,
    })
  }

  return (
    <div className="aphoto">
      <img src={photo.thumb} alt={caption} />
      <button className="del" type="button" onClick={remove} aria-label="Eliminar">×</button>
      <div className="capedit">
        <input
          value={caption}
          placeholder="Adicionar legenda…"
          onChange={(e) => setCaption(e.target.value)}
          onBlur={saveCaption}
        />
      </div>
    </div>
  )
}

export default function Photos({ currentEdition, editions, photos = [], editionName }) {
  const [files, setFiles] = useState([])
  const [caption, setCaption] = useState('')
  const [uploading, setUploading] = useState(false)
  const inputRef = useRef(null)

  function upload() {
    if (files.length === 0) return
    setUploading(true)
    router.post(
      '/photos',
      { edition_slug: currentEdition.slug, caption, images: files },
      {
        forceFormData: true,
        preserveScroll: true,
        onFinish: () => {
          setUploading(false)
          setFiles([])
          setCaption('')
          if (inputRef.current) inputRef.current.value = ''
        },
      }
    )
  }

  return (
    <AdminLayout currentEdition={currentEdition} editions={editions} active="photos">
      <div className="sechead">
        <h2>Fotos</h2>
        <div className="rule" />
        <div className="note">{editionName} · {photos.length} fotos</div>
      </div>

      <div className="uploader">
        <div className="big">Carregar fotos</div>
        <div className="sub">Seleciona várias fotos de uma vez. Legenda opcional aplicada a este lote.</div>
        <div className="uploader-row">
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => setFiles(Array.from(e.target.files))}
          />
          <input
            type="text"
            className="cap-input"
            placeholder="Legenda (opcional)"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          />
          <button className="btn" type="button" onClick={upload} disabled={uploading || files.length === 0}>
            {uploading ? 'A carregar…' : `Carregar ${files.length || ''} fotos`}
          </button>
        </div>
      </div>

      {photos.length === 0 ? (
        <p className="gallery-empty">Ainda não há fotos desta edição.</p>
      ) : (
        <div className="agrid">
          {photos.map((p) => (
            <PhotoCard key={p.id} photo={p} editionSlug={currentEdition.slug} />
          ))}
        </div>
      )}
    </AdminLayout>
  )
}
